var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M84.085,128H28.288c-3.301,0-5.985-2.662-5.985-5.936v-36.33h4v36.33c0,1.066,0.891,1.936,1.985,1.936 h55.797c1.094,0,1.983-0.869,1.983-1.936v-16.092h4v16.092C90.068,125.338,87.384,128,84.085,128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M90.068,65.496h-4V5.936c0-1.067-0.89-1.936-1.983-1.936H28.288c-1.095,0-1.985,0.869-1.985,1.936v15.229 h-4V5.936C22.303,2.663,24.987,0,28.288,0h55.797c3.299,0,5.983,2.663,5.983,5.936V65.496z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.195,
    y: 106.287,
    fill: "#282D33",
    width: 49.981,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.195,
    y: 16.731,
    fill: "#282D33",
    width: 49.981,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.535,
    y: 8.793,
    fill: "#282D33",
    width: 21.303,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.583,
    y: 113.734,
    fill: "#282D33",
    width: 5.204,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M22.436,78.914V65.4h-9.449V26.239h63.652V65.4H37.558L22.436,78.914z M16.986,61.399h9.449v8.575 l9.595-8.575h36.608V30.239H16.986V61.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.641,
    y: 39.612,
    fill: "#282D33",
    width: 36.343,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.641,
    y: 48.661,
    fill: "#282D33",
    width: 36.343,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M105.564,112.754L90.441,99.238H57.868V71.643h57.146v27.596h-9.449V112.754z M61.868,95.238h30.101 l9.596,8.576v-8.576h9.449V75.643H61.868V95.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.618,
    y: 83.73,
    fill: "#282D33",
    width: 36.346,
    height: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.ead8d6557288552bd92ba7faf2f7cb05.svg";
export { ForwardRef as ReactComponent };